var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "expand_circle_down"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1263_5996",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1263_5996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand_circle_down_2",
    d: "M7.99967 10.334L10.9997 7.33398L10.0497 6.40065L7.99967 8.45065L5.94967 6.40065L4.99967 7.33398L7.99967 10.334ZM7.99967 14.6673C7.07745 14.6673 6.21079 14.4923 5.39967 14.1423C4.58856 13.7923 3.88301 13.3173 3.28301 12.7173C2.68301 12.1173 2.20801 11.4118 1.85801 10.6007C1.50801 9.78954 1.33301 8.92287 1.33301 8.00065C1.33301 7.07843 1.50801 6.21176 1.85801 5.40065C2.20801 4.58954 2.68301 3.88398 3.28301 3.28398C3.88301 2.68398 4.58856 2.20898 5.39967 1.85898C6.21079 1.50898 7.07745 1.33398 7.99967 1.33398C8.9219 1.33398 9.78856 1.50898 10.5997 1.85898C11.4108 2.20898 12.1163 2.68398 12.7163 3.28398C13.3163 3.88398 13.7913 4.58954 14.1413 5.40065C14.4913 6.21176 14.6663 7.07843 14.6663 8.00065C14.6663 8.92287 14.4913 9.78954 14.1413 10.6007C13.7913 11.4118 13.3163 12.1173 12.7163 12.7173C12.1163 13.3173 11.4108 13.7923 10.5997 14.1423C9.78856 14.4923 8.9219 14.6673 7.99967 14.6673ZM7.99967 13.334C9.48856 13.334 10.7497 12.8173 11.783 11.784C12.8163 10.7507 13.333 9.48954 13.333 8.00065C13.333 6.51176 12.8163 5.25065 11.783 4.21732C10.7497 3.18398 9.48856 2.66732 7.99967 2.66732C6.51079 2.66732 5.24967 3.18398 4.21634 4.21732C3.18301 5.25065 2.66634 6.51176 2.66634 8.00065C2.66634 9.48954 3.18301 10.7507 4.21634 11.784C5.24967 12.8173 6.51079 13.334 7.99967 13.334Z",
    fill: "#C9B2B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandCircleDown);
export default __webpack_public_path__ + "static/media/expand_circle_down.7335396b8c394fea0f5ac3e0078ca1d4.svg";
export { ForwardRef as ReactComponent };